import { gql } from '@apollo/client'

export const Query = gql`
  query Package($companyId: ID!, $filters: PackageFilters) {
    packages(companyId: $companyId, filters: $filters, first: 1) {
      nodes {
        id
        name
        costCents
        rateCents
        availableToEvents
        displayOnWebsite
        description
        revenueCents
        returnOnInvestment
        categories {
          id
          name
          color
        }
        images {
          id
          url
        }
        assetTypes {
          id
          costCents
        }
      }
      pageInfo { startCursor endCursor hasNextPage hasPreviousPage }
    }
  }
`
